import { render, staticRenderFns } from "./DojinPeripheral.vue?vue&type=template&id=348f3b9b&scoped=true&"
import script from "./DojinPeripheral.vue?vue&type=script&lang=js&"
export * from "./DojinPeripheral.vue?vue&type=script&lang=js&"
import style0 from "./DojinPeripheral.vue?vue&type=style&index=0&id=348f3b9b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "348f3b9b",
  null
  
)

component.options.__file = "DojinPeripheral.vue"
export default component.exports